// components/FuturesTab.jsx
import { useEffect } from "react";
import useFutures from "../../hooks/useFutures";
import "./FuturesTab.css";

// const FuturesTab = ({ securityId, symbol }) => {
//   const { futuresData, futuresLoading, futuresError, getFutures } =
//     useFutures();

//   useEffect(() => {
//     if (securityId) {
//       getFutures(securityId);
//     }
//   }, [securityId]);

//   if (futuresLoading) {
//     return (
//       <div className="futures-loading">
//         <p>Loading futures data...</p>
//       </div>
//     );
//   }

//   if (futuresError) {
//     return (
//       <div className="futures-error">
//         <p>{futuresError}</p>
//       </div>
//     );
//   }

//   if (!futuresData?.contracts?.length) {
//     return (
//       <div className="futures-empty">
//         <p>No active futures contracts for {symbol}</p>
//       </div>
//     );
//   }

//   const data = futuresData;
//   console.log("data from futyres", data);

//   const formatNumber = (num) => {
//     if (num == null) return "—";
//     return Number(num).toLocaleString("en-IN");
//   };

//   const formatVolume = (vol) => {
//     if (vol == null) return "—";
//     const num = Number(vol);
//     if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
//     if (num >= 100000) return `${(num / 100000).toFixed(2)} L`;
//     return num.toLocaleString("en-IN");
//   };

//   return (
//     <div className="futures-tab-container">
//       {/* Spot Price Header */}
//       <div className="futures-spot-header">
//         <div className="futures-spot-info">
//           <span className="futures-spot-label">Spot Price</span>
//           <span className="futures-spot-price">
//             ₹{formatNumber(data.spotPrice)}
//           </span>
//         </div>
//         <div className="futures-meta">
//           <span className="futures-type-badge">
//             {data.type === "INDEX" ? "Index Futures" : "Stock Futures"}
//           </span>
//           <span className="futures-lot">
//             Lot Size: {data.contracts[0]?.lotSize || "—"}
//           </span>
//         </div>
//       </div>

//       {/* Futures Contracts Table */}
//       <div className="futures-table-wrap">
//         <table className="futures-table">
//           <thead>
//             <tr>
//               <th>Expiry</th>
//               <th>Open</th>
//               <th>High</th>
//               <th>Low</th>
//               <th>Close</th>
//               <th>LTP</th>
//               <th>Change</th>
//               <th>%Chg</th>
//               <th>Volume</th>
//               <th>OI</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.contracts.map((contract) => {
//               const isPositive = contract.change > 0;
//               const isNegative = contract.change < 0;

//               return (
//                 <tr key={contract.securityId}>
//                   <td className="futures-expiry-cell">
//                     <span className="futures-expiry-date">
//                       {contract.expiryDate}
//                     </span>
//                     <span className="futures-contract-name">
//                       {contract.displayName}
//                     </span>
//                   </td>
//                   <td>
//                     {contract.open ? `₹${formatNumber(contract.open)}` : "—"}
//                   </td>
//                   <td>
//                     {contract.high ? `₹${formatNumber(contract.high)}` : "—"}
//                   </td>
//                   <td>
//                     {contract.low ? `₹${formatNumber(contract.low)}` : "—"}
//                   </td>
//                   <td>
//                     {contract.close ? `₹${formatNumber(contract.close)}` : "—"}
//                   </td>
//                   <td className="futures-ltp-cell">
//                     {contract.ltp ? `₹${formatNumber(contract.ltp)}` : "—"}
//                   </td>
//                   <td
//                     className={
//                       isPositive
//                         ? "futures-green"
//                         : isNegative
//                           ? "futures-red"
//                           : ""
//                     }
//                   >
//                     {contract.change != null
//                       ? `${isPositive ? "+" : ""}${contract.change}`
//                       : "—"}
//                   </td>
//                   <td
//                     className={
//                       isPositive
//                         ? "futures-green"
//                         : isNegative
//                           ? "futures-red"
//                           : ""
//                     }
//                   >
//                     {contract.changePercent != null
//                       ? `${isPositive ? "+" : ""}${contract.changePercent}%`
//                       : "—"}
//                   </td>
//                   <td>{formatVolume(contract.volume)}</td>
//                   <td>{formatVolume(contract.oi)}</td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       {/* Premium / Discount to Spot */}
//       {data.spotPrice && (
//         <div className="futures-premium-section">
//           <h4>Futures Premium / Discount</h4>
//           <div className="futures-premium-grid">
//             {data.contracts.map((contract) => {
//               if (!contract.ltp || !data.spotPrice) return null;
//               const premium = contract.ltp - data.spotPrice;
//               const premiumPct = ((premium / data.spotPrice) * 100).toFixed(2);
//               const isPositive = premium >= 0;

//               return (
//                 <div className="futures-premium-card" key={contract.securityId}>
//                   <span className="futures-premium-label">
//                     {contract.displayName}
//                   </span>
//                   <span
//                     className={`futures-premium-value ${isPositive ? "futures-green" : "futures-red"}`}
//                   >
//                     {isPositive ? "+" : ""}
//                     {premium.toFixed(2)} ({isPositive ? "+" : ""}
//                     {premiumPct}%)
//                   </span>
//                   <span className="futures-premium-tag">
//                     {isPositive ? "Premium" : "Discount"}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// components/FuturesTab.jsx

const FuturesTab = ({ securityId, symbol, spotPrice }) => {
  const { futuresData, futuresLoading, futuresError, getFutures } =
    useFutures();

  // Fetch initial + start auto-refresh
  useEffect(() => {
    if (!securityId) return;

    getFutures(securityId);
  }, [securityId]);
  console.log("Futures Data", futuresData);
  if (futuresLoading) {
    return (
      <div className="futures-loading">
        <p>Loading futures data...</p>
      </div>
    );
  }

  if (futuresError) {
    return (
      <div className="futures-error">
        <p>{futuresError}</p>
      </div>
    );
  }

  if (!futuresData?.contracts?.length) {
    return (
      <div className="futures-empty">
        <p>No active futures contracts for {symbol}</p>
      </div>
    );
  }

  const data = futuresData;
  const contracts = data.contracts;

  const formatNumber = (num) => {
    if (num == null) return "—";
    return Number(num).toLocaleString("en-IN");
  };

  const formatVolume = (vol) => {
    if (vol == null) return "—";
    const num = Number(vol);
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} L`;
    return num.toLocaleString("en-IN");
  };

  return (
    <div className="futures-tab-container">
      {/* Spot Price Header */}
      <div className="futures-spot-header">
        <div className="futures-spot-info">
          <span className="futures-spot-label">Spot Price</span>
          <span className="futures-spot-price">
            {`₹${formatNumber(spotPrice)}`}
          </span>
        </div>
        <div className="futures-meta">
          <span className="futures-type-badge">
            {data.type === "INDEX" ? "Index Futures" : "Stock Futures"}
          </span>
          <span className="futures-lot">
            Lot Size: {contracts[0]?.lotSize || "—"}
          </span>
        </div>
      </div>

      {/* Futures Contracts Table */}
      <div className="futures-table-wrap">
        <table className="futures-table">
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>Expiry</th>
              <th>Open</th>
              <th>High</th>
              <th>Low</th>
              <th>Close</th>
              <th>LTP</th>
              <th>Chg</th>
              <th>%Chg</th>
              <th>Volume</th>
              <th>OI</th>
            </tr>
          </thead>
          <tbody>
            {contracts.map((c) => {
              const isPos = c.change > 0;
              const isNeg = c.change < 0;
              const colorClass = isPos
                ? "futures-green"
                : isNeg
                  ? "futures-red"
                  : "";

              return (
                <tr key={c.securityId}>
                  <td style={{ textAlign: "left" }}>
                    <div className="futures-expiry-cell">
                      <span className="futures-expiry-date">
                        {c.expiryDate}
                      </span>
                      <span className="futures-contract-name">
                        {c.displayName}
                      </span>
                    </div>
                  </td>
                  <td>{c.open ? `₹${formatNumber(c.open)}` : "—"}</td>
                  <td>{c.high ? `₹${formatNumber(c.high)}` : "—"}</td>
                  <td>{c.low ? `₹${formatNumber(c.low)}` : "—"}</td>
                  <td>{c.close ? `₹${formatNumber(c.close)}` : "—"}</td>
                  <td className="futures-ltp-cell">
                    {c.ltp ? `₹${formatNumber(c.ltp)}` : "—"}
                  </td>
                  <td className={colorClass}>
                    {c.change != null ? `${isPos ? "+" : ""}${c.change}` : "—"}
                  </td>
                  <td className={colorClass}>
                    {c.changePercent != null
                      ? `${isPos ? "+" : ""}${c.changePercent}%`
                      : "—"}
                  </td>
                  <td>{formatVolume(c.volume)}</td>
                  <td>{formatVolume(c.oi)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Premium / Discount */}
      {/* {data.spotPrice && contracts.some((c) => c.ltp) && (
        <div className="futures-premium-section">
          <h4>Futures Premium / Discount</h4>
          <div className="futures-premium-grid">
            {contracts.map((c) => {
              if (!c.ltp || !data.spotPrice) return null;
              const premium = c.ltp - data.spotPrice;
              const premiumPct = ((premium / data.spotPrice) * 100).toFixed(2);
              const isPos = premium >= 0;

              return (
                <div className="futures-premium-card" key={c.securityId}>
                  <span className="futures-premium-label">{c.displayName}</span>
                  <span
                    className={`futures-premium-value ${isPos ? "futures-green" : "futures-red"}`}
                  >
                    {isPos ? "+" : ""}
                    {premium.toFixed(2)} ({isPos ? "+" : ""}
                    {premiumPct}%)
                  </span>
                  <span className="futures-premium-tag">
                    {isPos ? "Premium" : "Discount"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )} */}
      {spotPrice && contracts.some((c) => c.ltp) && (
        <div className="futures-premium-section">
          <h4>Futures Premium / Discount</h4>
          <div className="futures-premium-grid">
            {contracts.map((c) => {
              if (!c.ltp || !spotPrice) return null;
              const premium = c.ltp - spotPrice;
              const premiumPct = ((premium / spotPrice) * 100).toFixed(2);
              const isPos = premium >= 0;

              return (
                <div className="futures-premium-card" key={c.securityId}>
                  <span className="futures-premium-label">{c.displayName}</span>
                  <span
                    className={`futures-premium-value ${isPos ? "futures-green" : "futures-red"}`}
                  >
                    {isPos ? "+" : ""}
                    {premium.toFixed(2)} ({isPos ? "+" : ""}
                    {premiumPct}%)
                  </span>
                  <span className="futures-premium-tag">
                    {isPos ? "Premium" : "Discount"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FuturesTab;
